import { Button } from "@mui/material";
import { useState } from "react";
import { uploadNewAceiteItems } from "utils/API/PublicadorMasivo/PublicadorMasivoAceiteAPI";
import { uploadNewCarterItems } from "utils/API/PublicadorMasivo/PublicadorMasivoCarterAPI";
import { uploadNewEnfItems } from "utils/API/PublicadorMasivo/PublicadorMasivoEnfAPI";
import { uploadNewKatItems } from "utils/API/PublicadorMasivo/PublicadorMasivoKatAPI";
import * as XLSX from "xlsx";

export default function PublicadorMasivo() {
  const [file, setFile] = useState(null);
  const [cellInput, setCellInput] = useState("");
  const [selectedSheetIndex, setSelectedSheetIndex] = useState('KAT');

  const sheetOptions = [
    { value: 'KAT', label: "Kit de Afinación" },
    { value: 'ENF', label: "Enfriadores" },
    { value: 'CAR', label: "Carter" },
    { value: 'ACE', label: "Aceite" },
  ];

  const handleFileUpload = (event) => {
    setFile(event.target.files[0]);
  };

  const parseCellInput = () => {
    const parts = cellInput.split(",");
    let cells = new Set();

    parts.forEach((part) => {
      if (part.includes("-")) {
        let [start, end] = part.split("-").map(Number);
        for (let i = start; i <= end; i++) {
          cells.add(i);
        }
      } else {
        cells.add(Number(part));
      }
    });

    return Array.from(cells);
  };

  const processFile = async () => {
    if (!file) {
      alert("Sube un archivo primero");
      return;
    }

    const reader = new FileReader();
    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });

      const sheet = workbook.Sheets[selectedSheetIndex];

      const validCells = parseCellInput();
      const rows = XLSX.utils.sheet_to_json(sheet, { header: 1 });

      let extractedData = [];

      rows.forEach((row, rowIndex) => {
        if (validCells.includes(rowIndex + 1)) {
          extractedData.push(row);
        }
      });

      if (selectedSheetIndex === 'KAT') {
        uploadNewKatItems(extractedData).then((response) => {
          if (response.success) {
            console.log("✅ Subida exitosa", response);
          } else {
            console.log("❌ Error:", response.error);
          }
        });
      }
      else if (selectedSheetIndex === 'ENF'){
        uploadNewEnfItems(extractedData).then((response) => {
          if (response.success) {
            console.log("✅ Subida exitosa");
          } else {
            console.log("❌ Error:", response.error);
          }
        });
      }
      else if (selectedSheetIndex === 'CAR'){
        uploadNewCarterItems(extractedData).then((response) => {
          if (response.success) {
            console.log("✅ Subida exitosa");
          } else {
            console.log("❌ Error:", response.error);
          }
        });
      }
      else if (selectedSheetIndex === 'ACE'){
        uploadNewAceiteItems(extractedData).then((response) => {
          if (response.success) {
            console.log("✅ Subida exitosa");
          } else {
            console.log("❌ Error:", response.error);
          }
        });
      }

    };

    reader.readAsArrayBuffer(file);
  };

  return (
    <div style={{ padding: "20px", maxWidth: "500px", margin: "auto" }}>
      <h2>Publicador Masivo</h2>

      <select
        value={selectedSheetIndex}
        onChange={(e) => setSelectedSheetIndex(e.target.value)}
        style={{ width: "100%", padding: "8px", marginBottom: "10px" }}
      >
        {sheetOptions.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>

      <input
        type="text"
        placeholder="Ej: 1,2,4-100"
        value={cellInput}
        onChange={(e) => setCellInput(e.target.value)}
        style={{ width: "100%", padding: "8px", marginBottom: "10px" }}
      />

      <input type="file" accept=".xlsx" onChange={handleFileUpload} />

      <Button
        onClick={processFile}
        variant="contained"
        style={{
          display: "block",
          marginTop: "10px",
          padding: "10px",
          color: "white",
          border: "none",
          cursor: "pointer",
        }}
      >
        Procesar Archivo
      </Button>
    </div>
  );
}